export default __webpack_public_path__ + "static/media/fa.bundle.335f3634.svg";